module.exports = __webpack_public_path__ + "img/Hero.f480cce2.png";